import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from '@posthog/react';
import config from '@/config/config';

const POSTHOG_KEY = config.POSTHOG_KEY;
const POSTHOG_HOST = config.POSTHOG_HOST;

if (POSTHOG_KEY && !posthog.__loaded) {
	posthog.init(POSTHOG_KEY, {
		api_host: POSTHOG_HOST,
		person_profiles: 'identified_only',
		capture_pageview: false,
		capture_pageleave: true,
		advanced_disable_feature_flags_on_first_load: true,
	});
	posthog.register({ environment: config.APP_ENV });
}

export function PostHogProvider({ children }: { children: React.ReactNode }) {
	if (!POSTHOG_KEY) {
		return <>{children}</>;
	}

	return <PHProvider client={posthog}>{children}</PHProvider>;
}
